import { useState } from "react";
import { useNavigate } from "react-router-dom";

const EmailVerification = (props) => {

    const history = useNavigate();


    return (
        <>
            <div className="bg-grey-100 centerr">
                <div className="Emailform">
                    <div className='verify-bg'>
                        <div className='container'>
                            <h1 className='text-white  verif-text'>Email Verifications</h1>
                        </div>

                    </div>
                    <div className='container verif p-5'>
                        <p className='fs18'>Thank you for choosing Next Capital. Please confirm your email address by clicking on the button below.
                        </p>
                        <a href={`https://iinvestv1.firebaseapp.com/__/auth/action?mode=${props.mode}&oobCode=${props.oobCode}&apiKey=${props.apiKey}&lang=${props.lang}`}>
                            <button className='btn-filled p-2 px-3 font-bold'>Verify Email Address</button>
                        </a>
                        <div className='mt-5'>
                            <hr />
                        </div>
                        <span className='t-grey-600'>If you didn't sign up for a Next Capital account, you may safely ignore this email.</span>

                        <div className='mt-3'>
                            <span className='t-grey-600'>  © Next Capital Limited. 2021</span>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default EmailVerification;